import WebSockHop from 'websockhop';

class SocketService {
    /*@ngInject*/
    constructor($window, $timeout, EventService, $log, SessionService,socket) {
        this.authenticated = false;
        this.status = 'Connecting';
        this.connected = false;
        this.debug = socket.debug;
        this.usePing = socket.ping;
        this.$timeout = $timeout;
        this.$log = $log;
        this.$window = $window;
        this.queue = [['getId']];

        this.wsh = new WebSockHop(socket.url);
        if(this.debug){
            WebSockHop.logger = (type, message)=>$log.log("WebSockHop: " + type + "-" + message);
        }
        if(this.usePing) {
            this.wsh.formatter = new WebSockHop.StringFormatter();
            this.wsh.formatter.pingMessage = '{"action":"ping"}';
            this.wsh.formatter.handlePong = message=> message == 'pong';
        }
        this.wsh.on('opened',()=>{
            this.status = 'Connected';
            this.connected = true;
            EventService.broadcast('websocket:open');
            this.queue.forEach(m=>this.send(m[0],m[1]));
            this.queue = [['getId']];
            if (this.debug) {
                $log.log('Socket Connected');
            }
        });
        this.wsh.on('closed',()=>{
            this.authenticated=false;
            this.status = 'Not Connected';
            this.connected = false;
            EventService.broadcast('websocket:close');
            if(this.debug){
                $log.log('Socket Closed');
            }
        });
        this.wsh.on('error',event=>{
            this.authenticated=false;
            if(this.status==='Connecting'){
                EventService.broadcast('websocket:404');
            }
            this.status = 'Not Connected';
            this.connected = false;
            EventService.broadcast('websocket:error');
            $log.log('Socket Error', event);
        });
        this.wsh.on('message', event=>{
            let message=angular.fromJson(event);
            if(message.action=='getId'){
                SessionService.set('id',message.data);
            }
            if(message.action=='closeConnection'){
                this.$window.location.reload(true);
            }
            EventService.broadcast('websocket:message',message);
            EventService.broadcast(message.action,message.data);
            if(this.debug){
                $log.log('Socket Recieved:',message);
            }
        });
        $window.onbeforeunload = () => {
            this.wsh.on('closed',()=>true);
            this.wsh.close();
        };

    }
    authenticate(){
        this.authenticated=true;
    }
    isAuthenticated(){
        return this.authenticated;
    }
    send(action,data){
        if(!this.connected){
            this.queue.push([action,data]);
            return;
        }
        let toSend = angular.toJson({action:action,data:data});
        if(this.debug){
            this.$log.log('Socket Sending:', toSend);
        }
        this.wsh.send(toSend);
    }
}
export default SocketService;


// WEBPACK FOOTER //
// ./public/app/services/socket.service.js